import { StepContainer } from '../components/StepContainer'
import { SingleSelect } from '../components/SingleSelect'
import { useOnboardingStore } from '../store/onboardingStore'
import type { DialysisType } from '../types/onboarding'
import { SingleSelectV2 } from '../components/v2'
import { usesAppLook } from '../lib/variant'

const options: { value: DialysisType; label: string; emoji: string; description: string }[] = [
  { value: 'hemodialysis', label: 'Hemodialysis', emoji: '🏥', description: 'In-center treatments' },
  { value: 'peritoneal', label: 'Peritoneal Dialysis', emoji: '🏠', description: 'Home peritoneal dialysis' },
  { value: 'home_hemo', label: 'Home Hemodialysis', emoji: '🩺', description: 'Hemodialysis at home' },
  { value: 'not_started', label: 'Not Started Yet', emoji: '📋', description: 'Preparing to start' },
]

// organic-v2: the app's dialysis_type marks (constants/onboarding.ts).
const V2_ICONS: Record<DialysisType, string> = {
  hemodialysis: 'dialysis-hemo',
  peritoneal: 'dialysis-peritoneal',
  home_hemo: 'dialysis-home-hemo',
  not_started: 'kidney-not-sure',
}
const v2Options = options.map(({ value, label, description }) => ({ value, label, description, icon: V2_ICONS[value] }))

export function DialysisStep() {
  const { data, goNext } = useOnboardingStore()

  return (
    <StepContainer
      title="What type of dialysis?"
      subtitle="Different dialysis types have different dietary needs"
      showContinue={false}
    >
      {usesAppLook() ? (
        <SingleSelectV2
          options={v2Options}
          value={data.dialysisType}
          onChange={(value) => goNext({ dialysisType: value })}
        />
      ) : (
        <SingleSelect
          options={options}
          value={data.dialysisType}
          onChange={(value) => goNext({ dialysisType: value })}
        />
      )}
    </StepContainer>
  )
}
